export default "__VITE_ASSET__CQhaLG2m__"